export default __webpack_public_path__ + "static/media/fuel.1866fb40.png";